import * as React from "react";
import type { SVGProps } from "react";
const SvgLinkExternal = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M10.8 2.4H6A3.6 3.6 0 0 0 2.4 6v12A3.6 3.6 0 0 0 6 21.6h12a3.6 3.6 0 0 0 3.6-3.6v-4.8m-6-10.8h6m0 0v5.4m0-5.4L11.4 12.6"
    />
  </svg>
);
export default SvgLinkExternal;
